import React, { useState } from "react";

const TabComponent2 = ({ tabs, onTabClick, index2 }) => {

    const handleTabChange = (tabName) => {
        onTabClick(tabName);
    };

    return (
        <div>
            <div className="justify-center space-x-0.5 text-xs">
                {tabs.map((tab, index) => (
                    <button
                        key={tab.value}
                        className={`px-2 py-2
			${index == 0 ? 'rounded-tl-[7px] rounded-bl-[7px]' : 'rounded-none'}
            ${index === 4 ? 'rounded-tr-[7px] rounded-br-[7px]' : "rounded-none"}
            ${index2 === tab.value ? "bg-yellow-500  text-white" : "bg-yellow-100 text-black"} 
								`}
                        onClick={() => handleTabChange(tab.value)}>
                        {tab.title}
                    </button>
                ))}
            </div>
        </div>
    );
};

export default TabComponent2;
